import React, { useContext, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { useForm } from 'react-hook-form';
import { Grid } from '@mui/material';
import { dropBoolean } from 'utils/drops';
import { GridContext } from 'contexts/GridContext';
import { DropsContext } from 'contexts/DropsContext';
import Container from 'components/Container';
import Dropdown from 'components/Dropdown';
import Button from 'components/Button';
import Header from 'components/Header';
import Input from 'components/Input';
import Card from 'components/Card';

const Manutenção = () => {
  const rotina = 'CrmFunil';
  const defaultValues = {
    etapa: '',
    descricao: '',
    orientacao: '',
    responsavel_id: null,
    tempomin: '',
    tempomax: '',
    manual: null,
    permite_proposta: null,
    proposta: null,
    concluir_lead: null,
  };
  const navigate = useNavigate();
  const { state } = useLocation();
  const { drops } = useContext(DropsContext);
  const { postLoading, postGrid } = useContext(GridContext);
  const { control, handleSubmit, reset } = useForm({ defaultValues });

  useEffect(() => {
    reset(state?.values);
  }, []);

  const onSubmit = (data) =>
    postGrid({
      data: { data, rotina },
      cb: () => navigate(-1),
    });

  return (
    <Container>
      <Header titulo={(Boolean(state) ? 'Editar' : 'Cadastrar') + ' Funil'} />
      <Card>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Input name="etapa" control={control} label="Etapa" type="number" />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Input name="descricao" control={control} label="Descrição" />
          </Grid>
          <Grid item xs={12}>
            <Input name="orientacao" control={control} label="Orientação" />
          </Grid>
          <Grid item xs={12}>
            <Dropdown
              name="responsavel_id"
              control={control}
              label="Responsável"
              options={drops?.Users}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Input
              name="tempomin"
              control={control}
              label="Tempo Mínimo"
              type="number"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Input
              name="tempomax"
              control={control}
              label="Tempo Máximo"
              type="number"
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <Dropdown
              name="manual"
              control={control}
              label="Manual"
              options={dropBoolean}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <Dropdown
              name="permite_proposta"
              control={control}
              label="Permite Proposta"
              options={dropBoolean}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <Dropdown
              name="proposta"
              control={control}
              label="Proposta"
              options={dropBoolean}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <Dropdown
              name="concluir_lead"
              control={control}
              label="Concluir Lead"
              options={dropBoolean}
            />
          </Grid>
          <Grid item xs={12} textAlign="center">
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmit(onSubmit)}
              loading={postLoading}
            >
              Salvar
            </Button>
          </Grid>
        </Grid>
      </Card>
    </Container>
  );
};

export default Manutenção;
